import React from "react";

import { useWeb3React } from "@web3-react/core";
import UnlockButton from "../Interface/UnlockButton";

import {ReactComponent as UnlockIcon} from "../../assets/unlock.svg";
import { useAuthorizeModal } from "../AuthorizeModal";
import './style.scss';
const shortenAddress = (address) => address.substr(0, 6) + "..." + address.substr(-6);

function Account() {
    const {account} = useWeb3React();
    const { showModal } = useAuthorizeModal();

    if (!account) {
        return <UnlockButton />;
    } else {
        return (
            <div className="account" onClick={showModal}>
                <div style={{display: "flex", alignItems: "center"}}>
                    <UnlockIcon />
                    <span style={{marginLeft: 10}}>{shortenAddress(account)}</span>
                </div>
            </div>
        )
    }
}

export default Account;
